export const isNumberText = (str?: string) => {
  if (!str) return false;
  return /^[0-9]*$/.test(str);
};
